import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PageState {
    currentPage: number;
}

const initialState: PageState = {
    currentPage: 0,
};

const pageSlice = createSlice({
    name: 'page',
    initialState,
    reducers: {
        SetPage(state, action: PayloadAction<number>) {
            state.currentPage = action.payload;
        },
    },
});

export const { SetPage } = pageSlice.actions;
export const Page = (state: { page: { currentPage: number; }; }) => state.page.currentPage;
export default pageSlice.reducer;